<script>
import { defineComponent } from 'vue';

import { getSliderContent } from '@/api/getSliderContentData';
import { setLocale } from '@/Common/numeralAmount';
import Loader from '@/components/Loader.vue';

import SliderContentBlockMain from './SliderContentBlockMain.vue';

export default defineComponent({
  name: 'SliderContentBlockApp' + Math.random(),
  components: {
    SliderContentBlockMain,
    Loader,
  },
  props: {
    locale: { type: String, required: true },
    startPageId: { type: Number, required: true },
    contentId: { type: Number, required: true },
  },
  data() {
    return {
      initError: false,
      initComplete: false,
      heading: '',
      items: [],
    };
  },
  created() {
    setLocale(this.locale);
    this.fetchSliderContentData();
  },
  methods: {
    async fetchSliderContentData() {
      try {
        const response = await getSliderContent(
          this.startPageId,
          this.contentId,
          this.locale,
        );
        this.heading = response.heading || '';
        this.items = response.items || [];
        this.initComplete = true;
        this.initError = false;
      } catch (error) {
        this.initError = true;
        this.initComplete = true;
      }
    },
  },
});
</script>
<template>
  <div class="container container--full-width">
    <div v-if="!initComplete">
      <Loader :loadingText="$t('loading')" />
    </div>
    <SliderContentBlockMain
      v-if="initComplete && !initError"
      :locale="locale"
      :heading="heading"
      :items="items"
    >
    </SliderContentBlockMain>
  </div>
</template>
